var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { useResizeObserver } from '@r1-frontend/shared/hooks/useResizeObserver';
import * as ST from '../styled';
var Subscriptions = function (_a) {
    var subscriptions = _a.subscriptions;
    var parentBlock = useRef(null);
    var innerBlock = useRef(null);
    var parentWidth = useResizeObserver(parentBlock).width;
    var innerWidth = useResizeObserver(innerBlock).width;
    var _b = useState(false), isVisibleArrows = _b[0], setIsVisibleArrows = _b[1];
    var _c = useState(false), isVisibleLeftArrow = _c[0], setIsVisibleLeftArrow = _c[1];
    var _d = useState(true), isVisibleRightArrow = _d[0], setIsVisibleRightArrow = _d[1];
    var _e = useState(0), slideIndex = _e[0], setSlideIndex = _e[1];
    var _f = useState(0), left = _f[0], setLeft = _f[1];
    useEffect(function () {
        if (innerWidth && parentWidth && innerWidth > parentWidth) {
            !isVisibleArrows && setIsVisibleArrows(true);
        }
        else {
            isVisibleArrows && setIsVisibleArrows(false);
            setLeft(0);
            setSlideIndex(0);
        }
    }, [innerWidth, parentWidth, isVisibleArrows]);
    var positions = useMemo(function () {
        var positionsArray = [0];
        if (innerWidth && parentWidth && innerWidth > parentWidth) {
            var count = Math.ceil(innerWidth / parentWidth);
            var piece = innerWidth / count;
            for (var i = 0; i < count - 1; i++) {
                positionsArray.push(piece * (i + 1));
            }
            var posIndex = slideIndex > positionsArray.length - 1 ? positionsArray.length - 1 : slideIndex;
            setLeft(-positionsArray[posIndex]);
            setSlideIndex(posIndex);
        }
        return positionsArray;
    }, [innerWidth, parentWidth, slideIndex]);
    var changeLeftPosition = useCallback(function (directionVector, extremeSlideIndex, callback) {
        if (positions) {
            var posIndex = slideIndex + directionVector;
            setLeft(-positions[posIndex]);
            if (posIndex === extremeSlideIndex) {
                callback();
            }
            setSlideIndex(posIndex);
        }
    }, [slideIndex, positions]);
    var leftArrowHandler = useCallback(function () {
        if (isVisibleLeftArrow) {
            !isVisibleRightArrow && setIsVisibleRightArrow(true);
            changeLeftPosition(-1, 0, function () {
                setIsVisibleLeftArrow(false);
            });
        }
    }, [changeLeftPosition, isVisibleRightArrow, isVisibleLeftArrow]);
    var rightArrowHandler = useCallback(function () {
        if (isVisibleRightArrow) {
            !isVisibleLeftArrow && setIsVisibleLeftArrow(true);
            changeLeftPosition(1, positions.length - 1, function () {
                setIsVisibleRightArrow(false);
            });
        }
    }, [changeLeftPosition, isVisibleLeftArrow, isVisibleRightArrow, positions.length]);
    var _g = useState({
        positionStart: 0,
        positionEnd: 0,
        isRightScroll: null,
        isDrawing: false,
    }), mousePositions = _g[0], setMousePositions = _g[1];
    var positionStart = mousePositions.positionStart, positionEnd = mousePositions.positionEnd, isRightScroll = mousePositions.isRightScroll, isDrawing = mousePositions.isDrawing;
    var onMouseDownHandler = useCallback(function (event) {
        var position = event.clientX || event.touches[0].clientX;
        setMousePositions(function (prev) { return (__assign(__assign({}, prev), { positionStart: position, isDrawing: true })); });
    }, []);
    var onMouseMoveHandler = useCallback(function (event) {
        var position = event.clientX || event.touches[0].clientX;
        if (isDrawing) {
            setMousePositions(function (prev) { return (__assign(__assign({}, prev), { positionEnd: position })); });
        }
    }, [isDrawing]);
    var onMouseUpHandler = useCallback(function () {
        if (isDrawing) {
            setMousePositions(function (prev) { return (__assign(__assign({}, prev), { positionStart: 0, positionEnd: 0, isDrawing: false })); });
        }
    }, [isDrawing]);
    useEffect(function () {
        if (isDrawing && positionStart !== 0 && positionEnd !== 0) {
            setMousePositions(function (prev) { return (__assign(__assign({}, prev), { isRightScroll: positionStart > positionEnd })); });
        }
    }, [isDrawing, positionStart, positionEnd]);
    useEffect(function () {
        if (isRightScroll !== null && !isDrawing) {
            if (isRightScroll) {
                rightArrowHandler();
            }
            else {
                leftArrowHandler();
            }
            setMousePositions(function (prev) { return (__assign(__assign({}, prev), { isRightScroll: null })); });
        }
    }, [isRightScroll, isDrawing, leftArrowHandler, rightArrowHandler]);
    return (<ST.SubsriptionsBlock>
            <ST.LeftArrow isVisible={isVisibleArrows && isVisibleLeftArrow} onClick={leftArrowHandler} data-test='left-arrow'/>
            <ST.Subscriptions ref={parentBlock}>
                <ST.InnerContainer ref={innerBlock} left={left} onMouseDown={onMouseDownHandler} onMouseMove={onMouseMoveHandler} onMouseUp={onMouseUpHandler} onTouchStart={onMouseDownHandler} onTouchMove={onMouseMoveHandler} onTouchEnd={onMouseUpHandler}>
                    {subscriptions.map(function (subscription) {
            return (<ST.SubsriptionsItem key={subscription.id} data-test='subscription'>
                                <WebpImage urlWebp={subscription.image_webp}>
                                    <LazyLoadImage src={subscription.image} alt={subscription.title} height={'30px'} width={subscription.width} visibleByDefault={true} draggable={false}/>
                                </WebpImage>
                            </ST.SubsriptionsItem>);
        })}
                </ST.InnerContainer>
            </ST.Subscriptions>
            <ST.RightArrow isVisible={isVisibleArrows && isVisibleRightArrow} onClick={rightArrowHandler} data-test='right-arrow'/>
        </ST.SubsriptionsBlock>);
};
export default Subscriptions;
